module.exports = __webpack_public_path__ + "static/media/logo.03fe2e1c.png";